export default "__VITE_ASSET__Cey1daSD__"